import { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import { toast } from "react-toastify";
import checkForm, {
  check_value_sal,
  checkDuplicate,
  dateValidate,
  emailValidate,
  isNumberKey,
  mobileValidate,
} from "./FormValidation";
import RLookUp from "./RLookUp";
import Loader from "../Loader";
// import swal from 'sweetalert';
import Mh1PersianDatePicker from "./Mh1PersianDatePicker";

import "./Form.scss";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";

import ComponentToPrintBarcodeInEditSection from "./ComponentToPrintBarcodeInEditSection";
import { useParams } from "react-router-dom";
import numeric from "../../utils/NumericFunction";
import str from "../../utils/StringFunctions";

export default function Form({ id, primaryKey }) {
  let tempId = useParams()["id"];
  let urlToSendRequest = localStorage.getItem("apiUrl");
  if (!id) {
    id = tempId;
    // urlToSendRequest
    window.location.hostname === "localhost"
      ? (urlToSendRequest = "http://localhost/Git/Delsa/Frm")
      : (urlToSendRequest = "/Frm");
  }

  const [data, setData] = useState();
  const [next, setNext] = useState(false);
  const [isItFromEdit, setIsItFromEdit] = useState(false);
  const formDOM = useRef(null);

  useEffect(() => {
  if (formDOM.current !== null) {
    const selectFields= formDOM.current.getElementsByClassName("custom-select");
    if (selectFields !== null) {
      for (let i = 0; i < selectFields.length; i++) {
        selectFields[i].classList.add("minWidth200");
      }
    }

    const inputFields = formDOM.current.getElementsByTagName("input");
    if (inputFields !== null) {
      for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].classList.add("w-100");
        inputFields[i].classList.add("minWidth200");
        inputFields[i].classList.add("text-center");
        inputFields[i].style.direction = "ltr";
        // TimeFields
        if (inputFields[i].classList.contains("timepicker-ui-input")) {
          inputFields[i].classList.add("width130");
          let today = new Date();
          inputFields[i].value =
            ("0" + today.getHours()).slice(-2) +
            ":" +
            ("0" + today.getMinutes()).slice(-2) +
            ":" +
            ("0" + today.getSeconds()).slice(-2);
        }
      }
    }
  }
  }, [formDOM.current]);

  useEffect(() => {
    setData();
    axios({
      method: "GET",
      url: `${urlToSendRequest}/get-form/`,
      params: primaryKey
        ? {
            id: id,
            state: "edit",
            pkValue: primaryKey,
          }
        : {
            id: id,
            state: "insert",
          },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setData(response.data[0]);
      setNext(response.data[0].nextBtn === "1" && true);
      if (primaryKey) {
        setIsItFromEdit(true);
      }
      // delete Request fire Two Times... So i copy that here
      if (formDOM.current) {
        if (formDOM.current.querySelectorAll(".delete-btn")) {
          let deleteBtnOnEditForm =
            formDOM.current.querySelectorAll(".delete-btn");
          if (deleteBtnOnEditForm.length > 0) {
            deleteBtnOnEditForm.forEach(addDeleteFunctionToEachBtn);
          }
        }
      }
    });
  }, [id, primaryKey]);

  // const [lookup, setLookup] = useState();

  //wanna use this state if need to Upload File or filesss
  const [selectedFileToUpload, setSelectedFileToUpload] = useState([]);

  //on change Function forEach input Box
  function OnChangeAddToStateFunction(inputBox, index) {
    inputBox.onchange = function (event) {
      event.preventDefault();
      let suffix = "." + event.target.files[0].name.split(".").at(-1);
      let newName = "";
      newName =
        Math.floor(new Date().getTime() / 1000) +
        "" +
        Math.floor(Math.random() * 10) +
        suffix;
      console.log(newName);

      var file = event.target.files[0];
      var blob = file.slice(0, file.size, file.type);
      let newFile = new File([blob], newName, { type: file.type });

      // every input box Must import One object in selectedFileToUpload State
      let newRow = { name: inputBox.name, selectedFile: newFile };
      const tempArray = [];
      if (selectedFileToUpload.length > 0) {
        let letMePush = true;
        // selectedFileToUpload.map((v) => {
        //     if (v.name === inputBox.name) {
        //         tempArray.push({"name": v.name, selectedFile: newFile});
        //         letMePush = false;
        //     } else {
        //         tempArray.push(v)
        //     }
        // });
        for (let i = 0; i < selectedFileToUpload.length; i++) {
          if (selectedFileToUpload[i].name === inputBox.name) {
            tempArray.push({
              name: selectedFileToUpload[i].name,
              selectedFile: newFile,
            });
            letMePush = false;
          } else {
            tempArray.push(selectedFileToUpload[i]);
          }
        }
        if (letMePush) {
          tempArray.push(newRow);
        }
      } else {
        tempArray.push(newRow);
      }

      console.log(tempArray);
      setSelectedFileToUpload(tempArray);
    };
  }

  function addDeleteFunctionToEachBtn(btn, index) {
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      debugger;

      swal("آیا از حذف این فایل اطمینان دارید؟", "", {
        buttons: {
          cancel: "لغو ",
          ok: "حذف فایل",
        },
        icon: "info",
      }).then((value) => {
        switch (value) {
          case "ok":
            axios({
              method: "delete",
              url: `${urlToSendRequest}/upload/`,
              params: {
                field: btn.getAttribute("data-name"),
                pkValue: primaryKey,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }).then((response) => {
              if (response.data.status) {
                toast.success(response.data.message);
                debugger;
                //  اینجا باید اگه اون استیت فایل های آپلودی  پر بود. یه دونه شو حذف کنم
                if (selectedFileToUpload.length > 0) {
                  let temp = selectedFileToUpload.filter(
                    (v) => v.name !== btn.name
                  );
                  setSelectedFileToUpload(temp);
                }
                debugger;

                const temp = btn.getAttribute("data-name");
                const tempIn = "[data-download-name=" + temp + "]";
                debugger;
                // let btnDataAttribiute =  formDOM.current.querySelector('[data-name="`${btnDataAttribiute}`"]');
                // formDOM.current.querySelector('[data-download-name="na_18"]')
                // اینجا هنوز یکم کار دارم 999
                // formDOM.current.querySelector(`[data-download-name="${btn.name}"]`).style.display = "none"
                formDOM.current.querySelector(tempIn).style.display = "none";
                debugger;
              } else {
                toast.info(response.data.message);
              }
            });
            break;
          default:
          //swal("Got away safely!");
        }
      });
    });
  }

  // if there is a formDOM.current please make changes onChange
  if (formDOM.current) {
    let uploadedNodeList = formDOM.current.querySelectorAll(".obj-41");
    if (uploadedNodeList.length > 0) {
      uploadedNodeList.forEach(OnChangeAddToStateFunction);
    }

    // let deleteBtnOnEditForm = formDOM.current.querySelectorAll(".delete-btn");
    // if (deleteBtnOnEditForm.length > 0) {
    //     deleteBtnOnEditForm.forEach(addDeleteFunctionToEachBtn)
    //
    // }
  }

  function sendFormDataToBack(formDomObject, entityName, getFromBackUrls) {
    setDisable(true);
    let entitiesArray = [];
    let formData = from2Object([formDomObject]);

    // wanna Replce file with file url if there is Somthing to Upload
    debugger;
    if (getFromBackUrls !== undefined ) {
      let fileNamesArray = [];
      if (formDomObject.querySelectorAll(".obj-41").length > 0) {
        function wannaTakeIds(v, index) {
          fileNamesArray.push(v.name);
        }

        // console.log(formData);
        let getObj41FileUpload = formDomObject.querySelectorAll(".obj-41");
        getObj41FileUpload.forEach(wannaTakeIds);
        // console.log(getFromBackUrls);
        for (let i = 0; i < fileNamesArray.length; i++) {
          const temp = fileNamesArray[i];
          const tempObject = getFromBackUrls.find((v) => v[temp]);
          if (tempObject) {
            formData[0][temp] = tempObject[temp];
          } else {
            formData[0][temp] = "";
          }
        }
      }
    }

    let entityData = {
      entity: entityName,
      data: formData,
    };

    let index = 0;
    entitiesArray[index] = entityData;

    // let HOST = localStorage.getItem("apiUrl");

    toast.info("در حال ارسال فرم...");
    // const formSubmitRequest = axios({
    axios({
      method: "POST",
      url: `${urlToSendRequest}/frm_submit/`,
      params: {
        kmo: localStorage.getItem("kmo"),
      },
      data: `data=${JSON.stringify({
        entities: entitiesArray,
      })}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        setDisable(false);
        response.data.barcodeCountUserInput=1;
        setSubmitResponse(response.data);
        // if (isItFromEdit === true) {
          const formFields = formDomObject.querySelectorAll("input");
          for (let field of formFields) {
            if (
              field.classList.contains("obj-51") ||
              field.classList.contains("obj-15") ||
              field.classList.contains("obj-37") ||
              field.style.display == "none"
            ) {
              field.value = field.value;
            } else {
              field.value = "";
            }
          }
        // } else {
        //   formDomObject.reset();
        // }
        // ;
        toast.success("ثبت فرم با موفقیت انجام شد");
      })
      .catch((error) => {
        setDisable(false);
        toast.error("ثبت فرم با مشکل مواجه شد");
        console.error(error.message);
      });
  }

  function formSubmitHandler(
    formDomObject,
    entityName,
    setSubmitResponse,
    next
  ) {
    console.log(selectedFileToUpload);
    //Remove commas in price
    let numberFieldsClass = formDomObject.querySelectorAll(".obj-25");
    if (numberFieldsClass.length > 0) {
      numberFieldsClass.forEach(plzForeEach);

      function plzForeEach(value, index) {
        formDomObject.querySelector(`#${value.id}`).value = formDomObject
          .querySelector(`#${value.id}`)
          .value.replaceAll(",", "");
      }
    }
    if (id === "869-s") {
      let price = formDOM.current.querySelector('[name="na_466"]').value;
      if (price > remainFactor) {
        price = "";
        toast.error("مبلغ نمیتواند بیش از مبلغ باقی مانده فاکتور باشد");
        return false;
      }
    }

    let getFromBackUrls = [];

    // اگه از ویرایش اومده بود و فایل آپلودی میخواست  الزامی بودنش رو حذف میکنم. تا توی ارسال دوباره اطلاعات گیر نده بده الزامیه
    function removeRequiedPlease(input, index) {
      input.removeAttribute("required");
    }

    if (isItFromEdit === true) {
      if (formDOM.current.querySelectorAll(".obj-41").length > 0) {
        formDOM.current
          .querySelectorAll(".obj-41")
          .forEach(removeRequiedPlease);
      }
    }

    if (checkForm([formDomObject])) {
      // if (true) {
      // in some cases we need to Upload File Or FileSss
      let needToUpload = false;
      formDomObject.querySelectorAll(".obj-41").length > 0
        ? (needToUpload = true)
        : (needToUpload = false);

      // functions for Upload Files
      if (needToUpload === true) {
        // حالا اگه سه تا فایل آپلود داشتیم و دوتا رو آپلود کرده بود؟ چک میکنم حتما سه تا رو آپلود کرده باشه
        // اگه از ویرایش اومده بود نیاز نیست چک کنی
        // if (isItFromEdit === false) {
        //     if (formDomObject.querySelectorAll(".obj-41").length !== selectedFileToUpload.length) {
        //         toast.error(" تعداد فایل آپلود شده صحیح نیست.");
        //         console.log(selectedFileToUpload);
        //         return;
        //     }
        // }

        let isEveryThingOkToSendAllFormToBack = true;
        selectedFileToUpload.map((v) => {
          const formData = new FormData();
          formData.append(v.name, v.selectedFile);
          axios({
            method: "post",
            url: `${urlToSendRequest}/upload/`,
            data: formData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }).then((response) => {
            response = response.data;
            if (response.status) {
              toast.info("در حال بارگزاری فایل...");
              //console.log(formDomObject);
              const toPush = {};
              toPush[v.name] = response.message;
              getFromBackUrls.push(toPush);
            } else {
              isEveryThingOkToSendAllFormToBack = false;
              toast.error(response.message);
            }
          });
        });

        setTimeout(() => {
          console.log("sendData Fired");
          if (isEveryThingOkToSendAllFormToBack === false) {
            toast.info("یک یا چند فایل آپلود نشدند... دوباره تلاش کنید.");
            return;
          }
          axios({
            method: "post",
            url: `${urlToSendRequest}/test/`,
            data: [],
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }).then((response) => {
            sendFormDataToBack(formDomObject, entityName, getFromBackUrls);
            setSelectedFileToUpload([]);
          });
        }, 1000);
      } else {
        // toast.info("نیاز به آپلود چیزی نیست بریم که اطلاعات فرم رو ارسال کنیم.");
        sendFormDataToBack(formDomObject, entityName);
      }
    } else {
      toast.error(" لطفا موارد ورودی را بررسی کنید.");
    }
  }

  function from2Object(formObjs) {
    let formData = [];

    for (let i = 0; i < formObjs.length; i++) {
      let form = new FormData(formObjs[i]);
      // let form = formObjs.eq(i).serializeArray();
      let datajson = {};
      for (const input of form.entries()) {
        datajson[input[0]] = input[1];
      }
      formData.push(datajson);
    }

    return formData;
  }
  const [remainFactor, setRemainFactor] = useState("");

  useEffect(() => {
    if (data !== undefined) {
      let lookupFields = formDOM.current.querySelectorAll(".obj-51");
      let selectFields = formDOM.current.querySelectorAll("select");
      for (let i of selectFields) {
        var selectedVal = i.getAttribute("value");
        let options = i.querySelectorAll("option");
        for (let option of options) {
          let value = option.value;
          if (value === selectedVal) {
            option.setAttribute("selected", "true");
          } else {
          }
        }
      }

      for (const field of lookupFields) {
        field.addEventListener("click", () => {
          sessionStorage.setItem(
            "rlookup",
            JSON.stringify({
              id: field.dataset.rlookupid,
              variables: field.dataset.variables,
            })
          );
          setModalIsOpen(true);
        });
      }

      // mrm15
      let obje25s = formDOM.current.querySelectorAll(".obj-25");
      for (const field of obje25s) {
        // console.log(toNumber);
        field.addEventListener("keyup", () => {
          for (let i = 1; i <= field.value.length; i++) {
            field.value = field.value.replace(",", "");
          }
          // if input in Not a number Remove input
          if (isNaN(field.value)) {
            field.value = field.value.replace(/\D/g, "");
          }
          let counter = 0;

          for (let i = 1; i <= field.value.length; i++) {
            if (
              i % (3 * (counter + 1) + counter) === 0 &&
              field.value.length - i !== 0
            ) {
              let tempVal = field.value;
              field.value = str.addStr(tempVal, field.value.length - i, ",");
              counter++;
              // console.log(field.value);
            }
          }
        });
      }
      //   formDOM.current.querySelector('[name="na_466"]').onclick = function () {
      //     let value = formDOM.current.querySelector('[name="na_454"]').value;
      //     if (value === "") {
      //       toast.error("ابتدا کد فاکتور را انتخاب کنید");
      //     } else {
      //       axios({
      //         method: "get",
      //         url: `${urlToSendRequest}/Formfunctions/`,
      //         params: {
      //           factorId: value,
      //         },
      //         headers: {
      //           Authorization: `Bearer ${localStorage.getItem("token")}`,
      //         },
      //       }).then(
      //         (response) =>
      //           (formDOM.current.querySelector('[name="na_466"]').value =
      //             response.data)
      //       );
      //     }
      //   };

      function setRemainPrice() {
        let value = formDOM.current.querySelector('[name="na_454"]').value;
        formDOM.current
          .querySelector('[name="na_466"]')
          .removeAttribute("readonly");
        if (value === "") {
          toast.error("ابتدا کد فاکتور را انتخاب کنید");
          formDOM.current
            .querySelector('[name="na_466"]')
            .setAttribute("readonly", true);
        } else {
          axios({
            method: "get",
            url: `${urlToSendRequest}/Formfunctions/`,
            params: {
              factorId: value,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }).then((response) => {
            formDOM.current.querySelector('[name="na_466"]').value =
              response.data.data;
            setRemainFactor(response.data.data);
          });
        }
      }
      if (id === "869-s") {
        formDOM.current.querySelector('[name="na_466"]').onclick =
          setRemainPrice;
        let factorId = formDOM.current.querySelector('[name="na_454"]');

        factorId.addEventListener("keydown", function (event) {
          if (event.keyCode === 9) {
            setRemainPrice();
          }
        });
      }



      // End mrm15

      for (let x of data.hidden) {
        for (let element of x.dependency) {
          formDOM.current
            .querySelector(`#${element.id}`)
            .closest(".form-group").style.display = "none";
        }
      }
      for (let x of data.hidden) {
        let field = formDOM.current.querySelector(`#${x.id}`);
        let value = field.value;
        for (let option of x.dependency) {
          formDOM.current
            .querySelector(`#${option.id}`)
            .closest(".form-group").style.display = "none";
          if (value === option.value) {
            let input = document.querySelector(`#${option.id}`);
            input.closest(".form-group").style.display = "block";
            input.setAttribute("required", "");
          }
        }

        field.addEventListener("change", () => {
          let value = field.value;
          for (let option of x.dependency) {
            formDOM.current
              .querySelector(`#${option.id}`)
              .closest(".form-group").style.display = "none";

            formDOM.current.querySelector(`#${option.id}`).value = "";
            formDOM.current.querySelector(`#${option.id}`).required = false;

            if (value === option.value) {
              let input = document.querySelector(`#${option.id}`);
              input.closest(".form-group").style.display = "block";
              input.setAttribute("required", "");
            }
          }
        });
      }

      let uniqueFields = formDOM.current.querySelectorAll("[data-unique=true]");
      for (const field of uniqueFields) {
        field.addEventListener("blur", (e) =>
          checkDuplicate(
            field.dataset.mj,
            field.name,
            e.target.value,
            field,
            field.name
          )
        );
      }
      // // این قسمت مربوط به فیلدهای دیت هست که میخایم بجاشون datepicker بذاریم
      // let dateFields=formDOM.current.querySelectorAll(".obj-15");
      // for(let field of dateFields){
      //     return(
      //         <DatePicker
      //         calendar={persian}
      //         className="form-control"
      //         placeholder="تاریخ"
      //         locale={persian_fa}
      //         calendarPosition="bottom-right"
      //         hideOnScroll
      //      />
      //     )
      // }

      let otherFields = formDOM.current.querySelectorAll("[data-type]");
      for (const field of otherFields) {
        switch (field.dataset.type) {
          case "email":
            field.addEventListener("blur", () => {
              emailValidate(field);
            });
            break;
          case "mobile":
            field.addEventListener("blur", () => {
              mobileValidate(field);
            });
            field.addEventListener("keypress", (e) => {
              isNumberKey(e);
            });
            break;
          case "year":
            field.addEventListener("blur", () => {
              check_value_sal(field, 1400);
            });
            break;
          case "date":
            field.addEventListener("blur", () => {
              dateValidate(field);
            });
            field.placeholder = "مانند 1400/01/01";
            break;

          default:
            console.trace(field);
            console.error("unknown input data-type attribute");
            break;
        }
      }
    }
  }, [data]);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  function lookupCallBackDataHandler(data) {
    for (const name in data) {
      formDOM.current[name].value = data[name];
    }
  }

  const [submitResponse, setSubmitResponse] = useState();

  // function barcodePrint() {
  //     let printWindow = window.open("barcodeprint.html");
  //
  //     let style =`{}`;
  //
  //     setTimeout(() => {
  //         printWindow.document.body.innerHTML =
  //             // document.querySelector(".barcode-container").outerHTML +
  //
  //             document.querySelector(".paperWidthToUse").outerHTML;
  //
  //
  //         printWindow.document.head.innerHTML = `<style>${style}</style>`;
  //     }, 100);
  // }

  // use Ref To ComponentToPrint
  const refToPrintBarcode = useRef();
  const [disable, setDisable] = useState(false);

  // dude i know this is Terrible, I has to paste this  dirty codes here  it show Date Box
  // if you Have a Better solution I Ask You To Do it Please
  const customstyledate = `
    
    .datePicker {
    border: none;
    width: 300px;
    direction: rtl;
    background-color: #fff;
    box-shadow: 0px 10px 30px rgba(0,0,0,0.3);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    color: #444;
    border-radius: 0 0 5px 5px;
     font-family: 'sahel';
}

    .datePicker button {
        background: none;
        color: #444
    }

    .datePicker td:first-child {
        padding-right: 5px  !important;
    }

.datePickerFriDay, .dateHoliday{
    color: #d10000;
}

.datePickerDay {
    min-width: 35px;
    min-height: 35px;
    text-align: center;
    cursor: pointer;
}

    .datePickerDay:hover {
        box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    }

.datePickerDaySelect {
    text-align: center;
    cursor: pointer;
    background-color: #00be8a;
    color: #fff;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
}

.datePickerToday {
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    background-color: #fffabe;
}

.datePickerHeader td {
    padding: 5px  !important;
    text-shadow: 0 0 1px #eee;
    color: #444;
    border-bottom: 1px solid #ccc
}

td.datePickerDay{
  padding: 5px  !important;  
}
.datePickerFooter td {
    padding-top: 5px !important;
    border-top: 1px solid #ccc
}
.datePicker td {
    padding: 5px !important;
 }
.datePicker tr , .datePicker td ,  .datePicker th {
 border:0px;
}
.datePickerHeader button, .datePickerFooter button {
    border-radius: 2px;
    border: none;
    cursor: pointer;
}

.datePickerHeader button {
    min-width: 30px;
    min-height: 30px;
    line-height: 0;
    vertical-align: middle;
    border: 1px solid #ccc;
    padding:0px
}

.datePickerFooter button {
    padding: 0px 8px 2px 8px;
    border: 1px solid #ccc;
    margin: 0 0 5px 5px;
   
}

    .datePickerHeader button:hover, .datePickerFooter button:hover {
        box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    }

.datePickerYear, .datePickerMonth {
    text-align: center;
    display: inline-block;
    height: 17px;
    vertical-align: middle;
}

.datePickerMonth {
    width: 45%;
}

.datePickerYear {
    width: 35%;
}

.mh1-icon-plus, .mh1-icon-minus {
    font-style: normal;
    opacity: .5;
}

/*font-size*/

.datePicker, .datePickerHeader button, .datePickerFooter button {
    font-size: 14px;
}

.datePickerHeader button {
    font-size: 20px;
}

/*font-size*/

/*responsive*/

 @media (max-width: 480px) {
    .datePicker {
        width: 250px
    }
     .datePicker,.datePickerMonth {
        font-size: 13px;
    }
 }

/*responsive*/
    `;

  // var Mh1PersianDatePicker = function () {
  //     var _dayName = new Array("شنبه",
  //         "یکشنبه",
  //         "دوشنبه",
  //         "سه‌شنبه‌",
  //         "چهارشنبه",
  //         "پنجشنبه‌",
  //         "جمعه");
  //     var _monthName = new Array("فروردین",
  //         "اردیبهشت",
  //         "خرداد",
  //         "تیر",
  //         "مرداد",
  //         "شهریور",
  //         "مهر",
  //         "آبان",
  //         "آذر",
  //         "دی",
  //         "بهمن",
  //         "اسفند");
  //
  //     var _today = null;
  //     var _datePicker = null;
  //     var _textBox = null;
  //     var _datePickerStyle = null;
  //     var _clicked = false;
  //     var _holidays = [];
  //
  //     function init() {
  //         // _datePicker = createElement("div", formDOM.current);
  //         _datePicker = createElement("div", document.body);
  //         _datePickerStyle = _datePicker.style;
  //         _datePickerStyle.position = "absolute";
  //         _datePickerStyle.zIndex = 10000000;
  //         _datePicker.onmousedown = function () {
  //             _clicked = true;
  //         };
  //         _datePicker.onclick = function () {
  //             _textBox.focus();
  //         };
  //     }
  //
  //     function hide() {
  //         // _datePickerStyle.visibility = "hidden";
  //         _datePickerStyle.display = "none";
  //     }
  //
  //     this.show = function (textBox, today, holidays) {
  //         if (_datePicker === null) {
  //             init();
  //         }
  //         _today = today;
  //         _textBox = textBox;
  //         _textBox.onblur = function () {
  //             if (!_clicked) {
  //                 hide();
  //             }
  //             _clicked = false;
  //         };
  //         _holidays = holidays ? holidays : [];
  //         var left = 0;
  //         var top = 0;
  //         var parent = _textBox;
  //         while (parent.offsetParent) {
  //             left += parent.offsetLeft;
  //             top += parent.offsetTop;
  //             parent = parent.offsetParent;
  //         }
  //         _datePickerStyle.left = left + "px";
  //         _datePickerStyle.top = top + _textBox.offsetHeight + "px";
  //         // _datePickerStyle.visibility = "visible";
  //         _datePickerStyle.display = "block";
  //
  //         draw(_textBox.value.length === 10 ? _textBox.value : _today);
  //     };
  //
  //     function setValue(date) {
  //         _textBox.value = date;
  //         _textBox.focus();
  //         hide();
  //
  //         _textBox.dispatchEvent(new Event('change'));
  //     }
  //
  //     function changeDay(date, day) {
  //         return date.substring(0, 8) + (day < 10 ? "0" : "") + day;
  //     }
  //
  //     function createElement(tag, parent) {
  //         var element = document.createElement(tag);
  //         parent.appendChild(element);
  //         return element;
  //     }
  //
  //     function draw(date) {
  //         _textBox.focus();
  //         var weekDay = getWeekDay(date.substring(0, 8) + "01");
  //
  //         setInnerHTML(_datePicker, "");
  //
  //         var table = createElement("table", _datePicker);
  //         setClassName(table, "datePicker");
  //         table.cellSpacing = 0;
  //
  //         var tr = table.insertRow(0);
  //         setClassName(tr, "datePickerHeader");
  //
  //         var td = createElement("td", tr);
  //         td.colSpan = 3;
  //
  //         var button = createElement("button", td);
  //         setInnerHTML(button, "<span class='mh1-icon-plus'>+</span>");
  //         button.onclick = function () { draw(nextMonth(date)); };
  //
  //         var span = createElement("span", td);
  //         setInnerHTML(span, _monthName[date.substring(5, 7) - 1]);
  //         setClassName(span, "datePickerMonth");
  //
  //         button = createElement("button", td);
  //         setInnerHTML(button, "<span class='mh1-icon-minus'>-</span>");
  //         button.onclick = function () { draw(previousMonth(date)); };
  //
  //         td = createElement("td", tr);
  //         td.colSpan = 4;
  //         td.style.textAlign = "left";
  //
  //         button = createElement("button", td);
  //         setInnerHTML(button, "<span class='mh1-icon-plus'>+</span>");
  //         button.onclick = function () { draw(nextYear(date)); };
  //
  //         span = createElement("span", td);
  //         setInnerHTML(span, date.substring(0, 4));
  //         setClassName(span, "datePickerYear");
  //
  //         button = createElement("button", td);
  //         setInnerHTML(button, "<span class='mh1-icon-minus'>-</span>");
  //         button.onclick = function () { draw(previousYear(date)); };
  //
  //         for (var row = 0; row < 7; row++) {
  //             tr = table.insertRow(row + 1);
  //             if (row === 5)
  //                 setClassName(tr, "datePickerThuDay");
  //             if (row === 6)
  //                 setClassName(tr, "datePickerFriDay");
  //
  //             else if (mod(row, 2) !== 1)
  //                 setClassName(tr, "datePickerRow");
  //             td = createElement("td", tr);
  //             setInnerHTML(td, _dayName[row]);
  //             for (var col = 0; col < 6; col++) {
  //                 var cellValue = col * 7 + row - weekDay + 1;
  //                 td = createElement("td", tr);
  //                 if (cellValue > 0 && cellValue <= getMonthDays(date)) {
  //                     setInnerHTML(td, cellValue);
  //                     var cellDate = changeDay(date, cellValue);
  //                     var cellClassName = "datePickerDay";
  //                     if (cellDate === _textBox.value)
  //                         cellClassName = "datePickerDaySelect";
  //                     else if (cellDate === _today)
  //                         cellClassName = "datePickerToday";
  //                     if (_holidays.indexOf(cellDate)>-1)
  //                         cellClassName += " dateHoliday";
  //                     setClassName(td, cellClassName);
  //                     td.onclick = function () { setValue(changeDay(date, this.innerHTML)); };
  //                 }
  //             }
  //         }
  //
  //         tr = table.insertRow(8);
  //         setClassName(tr, "datePickerFooter");
  //
  //         td = createElement("td", tr);
  //         td.colSpan = 2;
  //
  //         button = createElement("button", td);
  //         setInnerHTML(button, "امروز");
  //         button.onclick = function () { setValue(_today); };
  //
  //         td = createElement("td", tr);
  //         td.colSpan = 5;
  //         td.style.textAlign = "left";
  //
  //         button = createElement("button", td);
  //         setInnerHTML(button, "خالی");
  //         button.onclick = function () { setValue(""); };
  //     }
  //
  //     function nextYear(date) {
  //         var dateArray = date.split("/");
  //         return (toInt(dateArray[0]) + 1).toString() + "/" + dateArray[1] + "/" + dateArray[2];
  //     }
  //
  //     function previousYear(date) {
  //         var dateArray = date.split("/");
  //         return (toInt(dateArray[0]) - 1).toString() + "/" + dateArray[1] + "/" + dateArray[2];
  //     }
  //
  //     function nextMonth(date) {
  //         var dateArray = date.split("/");
  //
  //         if (dateArray[1] < 9)
  //             return dateArray[0] + "/0" + (toInt(dateArray[1].substring(1, 2)) + 1).toString() + "/" + dateArray[2];
  //         if (dateArray[1] === 9)
  //             return dateArray[0] + "/10/" + dateArray[2];
  //         if (dateArray[1] < 12)
  //             return dateArray[0] + "/" + (toInt(dateArray[1]) + 1).toString() + "/" + dateArray[2];
  //         return (toInt(dateArray[0]) + 1).toString() + "/01/" + dateArray[2];
  //     }
  //
  //     function previousMonth(date) {
  //         var dateArray = date.split("/");
  //         if (dateArray[1] > 10)
  //             return dateArray[0] + "/" + (toInt(dateArray[1]) - 1).toString() + "/" + dateArray[2];
  //         if (dateArray[1] > 1)
  //             return dateArray[0] + "/0" + (dateArray[1] - 1).toString() + "/" + dateArray[2];
  //         return (toInt(dateArray[0]) - 1).toString() + "/12/" + dateArray[2];
  //     }
  //
  //     function isLeapYear(year) {
  //         return (((((year - 474) % 2820) + 512) * 682) % 2816) < 682;
  //     }
  //
  //     function mod(a, b) {
  //         return Math.abs(a - (b * Math.floor(a / b)));
  //     }
  //
  //     function getWeekDay(date) {
  //         return mod(getDiffDays("1392/03/25", date), 7);
  //     }
  //
  //     function getDiffDays(date1, date2) {
  //         var diffDays = getDays(date2) - getDays(date1);
  //         var dateArray1 = date1.split("/");
  //         var dateArray2 = date2.split("/");
  //         var y1 = (dateArray1[0] < dateArray2[0]) ? dateArray1[0] : dateArray2[0];
  //         var y2 = (dateArray1[0] < dateArray2[0]) ? dateArray2[0] : dateArray1[0];
  //         for (var y = y1; y < y2; y++)
  //             if (isLeapYear(y))
  //                 diffDays += (dateArray1[0] < dateArray2[0]) ? 366 : -366;
  //             else
  //                 diffDays += (dateArray1[0] < dateArray2[0]) ? 365 : -365;
  //         return toInt(diffDays);
  //     }
  //
  //     function setInnerHTML(element, html) {
  //         element.innerHTML = html;
  //     }
  //
  //     function setClassName(element, className) {
  //         element.className = className;
  //     }
  //
  //     function toInt(text) {
  //         return parseInt(text, 10);
  //     }
  //
  //     function getDays(date) {
  //         var dateArray = date.split("/");
  //         if (dateArray[1] < 8)
  //             return (dateArray[1] - 1) * 31 + toInt(dateArray[2]);
  //         return 6 * 31 + (dateArray[1] - 7) * 30 + toInt(dateArray[2]);
  //     }
  //
  //     function getMonthDays(date) {
  //         var dateArray = date.split("/");
  //         if (dateArray[1] < 7)
  //             return 31;
  //         if (dateArray[1] < 12)
  //             return 30;
  //         return isLeapYear(dateArray[0]) ? 30 : 29;
  //     }
  // };

  var _mh1PersianDatePicker = new Mh1PersianDatePicker();

  Mh1PersianDatePicker.Show = function (textBox, today, holidays) {
    _mh1PersianDatePicker.show(textBox, today, holidays);
  };

  let today = new Date().toLocaleDateString("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  today = numeric.p2e(today);

  function plzForeEachDear(value, index) {
    // formDomObject.querySelector(`#${value.id}`).value = formDomObject.querySelector(`#${value.id}`).value.replaceAll(",","");
    value.addEventListener("click", function () {
      Mh1PersianDatePicker.Show(this, today);
    });
  }

  // useEffect(() => {
  if (formDOM.current !== null) {
    let numberFieldsClassplz = formDOM.current.querySelectorAll(".obj-15");
    if (numberFieldsClassplz !== null) {
      numberFieldsClassplz.forEach(plzForeEachDear);
    }
  }
  // }, [formDOM.current]);

  return data !== undefined ? (
    <>
      <style>{customstyledate}</style>
      <h3 className="page-header">{data.title}</h3>
      <div className="form-component">
        {modalIsOpen ? (
          <RLookUp
            id={JSON.parse(sessionStorage.getItem("rlookup")).id}
            variables={JSON.parse(sessionStorage.getItem("rlookup")).variables}
            callBackDataHandler={lookupCallBackDataHandler}
            modalHandler={[modalIsOpen, setModalIsOpen]}
          />
        ) : null}
        <form
          ref={formDOM}
          className="formContainer"
          dangerouslySetInnerHTML={{
            __html: data === undefined ? "" : data.form[0],
          }}
        ></form>
        <button
          className="btn btn-success submit-button"
          disabled={disable}
          onClick={() => {
            formSubmitHandler(
              formDOM.current,
              data.entity,
              setSubmitResponse,
              next
            );
          }}
        >
          ثبت
        </button>
        {id === "473-s" && (
          <>
            <div className="barcodeLabelContainer">
              <div className="border-black" style={{}}>
                <div className="barcodeLabel">
                  <div
                    className={"border border-dark rounded-3"}
                    style={{ margin: " 0 auto", width: "max-content" }}
                  >
                    <ComponentToPrintBarcodeInEditSection
                      submitResponse={submitResponse}
                      ref={refToPrintBarcode}
                    />
                  </div>
                </div>
              </div>
            </div>

            <br />
            <div className={"text-center"}>
              {/* here is Section Code To Print */}
              <ReactToPrint content={() => refToPrintBarcode.current}>
                <PrintContextConsumer>
                  {({ handlePrint }) => (
                    <button
                      disabled={submitResponse === undefined}
                      className="btnCustom btnSubmit"
                      onClick={handlePrint}
                    >
                      پرینت بارکد
                    </button>
                  )}
                </PrintContextConsumer>
              </ReactToPrint>
              {/* End ::: here is Section Code To Print */}
            </div>
          </>
        )}
      </div>
    </>
  ) : (
    <Loader />
  );
}
